// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import StepBackwardOutlinedSvg from "@ant-design/icons-svg/es/asn/StepBackwardOutlined";
import AntdIcon from '../components/AntdIcon';

var StepBackwardOutlined = function StepBackwardOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: StepBackwardOutlinedSvg
  }));
};

StepBackwardOutlined.displayName = 'StepBackwardOutlined';
export default React.forwardRef(StepBackwardOutlined);